var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/box.ts
import "@adornis/buildify/client/components/x-buildify-color-picker.js";
import "@adornis/buildify/client/components/x-buildify-spacing-picker.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/popover/x-dropdown-selection";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BOX_KEY, BOX_SCHEMA } from "../../schema/nodes/box.js";
import { PARAGRAPH_KEY } from "../../schema/nodes/paragraph.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { MenuItemGroup } from "../types.js";
import { isNodeSelection } from "../util.js";
var boxEditor = ({
  content,
  contentController,
  controllerBaseKeyPath,
  host
}) => {
  return html`
    <x-flex space="sm">
      <x-input
        clearable
        placeholder="Höhe des Containers"
        ${contentController.field(...controllerBaseKeyPath, "height")}
      ></x-input>
      <x-buildify-border-radius-picker
        clearable
        select
        ${contentController.field(...controllerBaseKeyPath, "borderRadius")}
      ></x-buildify-border-radius-picker>
      <x-buildify-color-picker
        clearable
        placeholder="Hintergrundfarbe"
        type="color"
        ${contentController.field(...controllerBaseKeyPath, "backgroundColor")}
      ></x-buildify-color-picker>
      <x-input
        clearable
        placeholder="Transparenz (0-100)"
        type="number"
        .value=${content.opacity ? content.opacity * 100 : void 0}
        @value-picked=${(e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement))
      return;
    target.removeAttribute("error");
    const eventValue = e.detail.value;
    const value = typeof eventValue === "number" ? eventValue === 0 ? 0 : eventValue / 100 : null;
    console.log("value: ", value);
    if (value !== null && (value < 0 || value > 1)) {
      target.setAttribute("error", "Nur Werte von 0 - 100 sind zugelassen!");
      return;
    }
    content.setValue("opacity", value, contentController.size);
  }}
      ></x-input>
    </x-flex>
  `;
};
var box = () => ({
  node: {
    name: BOX_KEY,
    schema: BOX_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.LAYOUT,
      label: "Box",
      icon: "inventory_2",
      run: (view) => runInsertNode(BOX_KEY, (state) => {
        return {
          content: [state.schema.nodes[PARAGRAPH_KEY].create()]
        };
      })(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor: boxEditor
});
var NodeBox = class extends BuildifyLitElement {
  content({ content, mode }) {
    return html`
      <div
        ${css({
      padding: content?.padding,
      border: mode === "edit" ? `1px solid ${this.colors.accent.shade(200)}` : "none",
      boxSizing: "border-box",
      background: content?.getBackgroundColorParsed(),
      borderRadius: content?.borderRadius ?? "unset",
      height: "100%"
    })}
      >
        <slot></slot>
      </div>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          height: this._data.value?.height ?? ""
        }
      }
    ];
  }
};
NodeBox = __decorateClass([
  customElement("node-box")
], NodeBox);
export {
  NodeBox,
  box,
  boxEditor
};
